import axios from 'axios';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';

export default class Fipe {

  public static async getMarcas(): Promise<GetMarcasResponse> {
    const response = await Fipe.instance.get<GetMarcasResponse>(`/fipe.php?tipo=3`);
    return response.data;
  }

  public static async getModelos(marca: number): Promise<GetModelosResponse> {
    const response = await Fipe.instance.get<GetModelosResponse>(`/fipe.php?tipo=3&marca=${marca}`);
    return response.data;
  }

  public static async getAnos(marca: number, modelo: number): Promise<GetAnosResponse> {
    const response = await Fipe.instance.get<GetAnosResponse>(`/fipe.php?tipo=3&marca=${marca}&modelo=${modelo}`);
    return response.data;
  }

  public static async getVeiculo(marca: number, modelo: number, ano: string): Promise<GetVeiculoResponse> {
    const response = await Fipe.instance.get<GetVeiculoResponse>(`/fipe.php?tipo=3&marca=${marca}&modelo=${modelo}&ano=${ano}`);
    return response.data;
  }

  public static async getFipe(fipe: string): Promise<GetFipesResponse> {
    const response = await Fipe.instance.get<GetFipesResponse>(`/fipe.php?tipo=fipe&code${fipe}`);
    return response.data;
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });
}
